import { render, staticRenderFns } from "./wedding.vue?vue&type=template&id=0d37cbff&scoped=true&"
import script from "./wedding.vue?vue&type=script&lang=js&"
export * from "./wedding.vue?vue&type=script&lang=js&"
import style0 from "./wedding.vue?vue&type=style&index=0&id=0d37cbff&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d37cbff",
  null
  
)

export default component.exports